import NativeClient from "@/client/native-client";
import { CommonRecipe, CommonRecipeTag } from "@/types/commonRecipe";
import { HTMLDivElementEvent, FavoriteRecipeClip, FavoriteHistoryRecipe, FavoriteSendedHistoryRecipe } from "@/types/favorites";

export const isEndOfScrollBottom = (event: HTMLDivElementEvent) => {
  if ((event.target.scrollTop + event.target.offsetHeight) >= (event.target.scrollHeight - 1)) {
    return true;
  }
  return false;
};

/** お気に入り系のAPIのレスポンスから、共通レシピ一覧への変換 */
export const createFavoriteRecipesToCommonRecipes = (clips: FavoriteRecipeClip[]) => {
  const commomList: CommonRecipe[] = [];
  for (const recipeElement of clips) {
    const element: CommonRecipe = new CommonRecipe();
    element.recipeId = recipeElement.recipeId;
    element.groupId = recipeElement.groupId;
    element.title = recipeElement.caption;
    element.imageUrl = recipeElement.imageUrl;
    element.type = recipeElement.type;
    element.applianceCategory = recipeElement.device;
    element.applianceCategoryId = recipeElement.applianceCategoryId;
    element.productId = recipeElement.productId;
    element.tags = [];
    for (const tag of recipeElement.tags) {
      element.tags.push(new CommonRecipeTag(tag.id, tag.name));
    }
    commomList.push(element);
  }
  return commomList;
};

/** 履歴取得APIのレスポンスから、共通レシピ一覧への変換 */
export const createFavoriteHistoryRecipesToCommonRecipes = (recipes: FavoriteHistoryRecipe[]) => {
  const commomList: CommonRecipe[] = [];
  for (const recipeElement of recipes) {
    const element: CommonRecipe = new CommonRecipe();
    element.recipeId = recipeElement.recipeId;
    element.groupId = recipeElement.groupId;
    element.title = recipeElement.title;
    if (recipeElement.images.length > 0) {
      element.imageUrl = recipeElement.images[0].main;
    } else {
      element.imageUrl = "";
    }
    element.type = recipeElement.type;
    element.applianceCategory = recipeElement.applianceCategory;
    element.applianceCategoryId = recipeElement.applianceCategoryId;
    element.productId = recipeElement.productId;
    element.tags = [];
    for (const tag of recipeElement.tags) {
      element.tags.push(new CommonRecipeTag(tag.id, tag.name));
    }
    commomList.push(element);
  }
  return commomList;
};

/** 送信履歴取得APIのレスポンスから、共通レシピ一覧への変換 */
export const createFavoriteSendedHistoryRecipesToCommonRecipes = (recipes: FavoriteSendedHistoryRecipe[]) => {
  const commonList: CommonRecipe[] = [];
  for (const recipeElement of recipes) {
    const element: CommonRecipe = new CommonRecipe();
    element.recipeId = recipeElement.recipeId;
    element.groupId = recipeElement.groupId;
    element.title = recipeElement.recipeName;
    element.imageUrl = recipeElement.imageUrl;
    element.type = "official";
    element.applianceCategory = recipeElement.applianceCategory;
    element.applianceCategoryId = recipeElement.applianceCategoryId;
    element.tags = [];
    commonList.push(element);
  }
  return commonList;
};
